export const minInputHeight = 25
export const defaultInputHeight = 42
